import axios from "axios";
import { domain } from "../../../Links/Links";

export async function purchasesHistoryRequest(setRequestStatus, setData) {
    setRequestStatus(true);

    const response = await axios.get(domain + '/purchases_history/' , {
        withCredentials: true,
    })

    console.log(response.data);

    if (response.data) {
        setData(response.data);
        setRequestStatus(false);
    }
}